"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var ExploreFill = function ExploreFill(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "ExploreFill"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "explore-fill"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2 10c0 0.663-0.537 1.2-1.2 1.2s-1.2-0.537-1.2-1.2c0-0.663 0.537-1.2 1.2-1.2v0c0.663 0 1.2 0.537 1.2 1.2v0zM20 10c0 5.523-4.477 10-10 10s-10-4.477-10-10c0-5.523 4.477-10 10-10v0c5.523 0 10 4.477 10 10v0zM14.28 5.42l-5.8 2.6c-0.203 0.097-0.363 0.257-0.457 0.454l-0.003 0.006-2.6 5.8c-0.018 0.031-0.029 0.069-0.029 0.109 0 0.122 0.098 0.22 0.22 0.22 0.040 0 0.078-0.011 0.11-0.029l-0.001 0.001 5.78-2.6c0.203-0.097 0.363-0.257 0.457-0.454l0.002-0.006 2.62-5.8c0.018-0.031 0.029-0.069 0.029-0.109 0-0.122-0.098-0.22-0.22-0.22-0.040 0-0.078 0.011-0.11 0.029l0.001-0.001z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = ExploreFill;
exports["default"] = _default;